import config from '../config';

const appConfig = config();
const { v2 } = appConfig.apiVersion;
const { apiPrefix } = appConfig;

export default class CompanyService {
  constructor(client) {
    this.client = client;
  }

  async getEmployees(companyId, query) {
    return this.client.get(
      `${apiPrefix}${v2}/companies/${companyId}/employees`,
      { params: query }
    );
  }

  async getStock(companyId, query = {}) {
    const params = {};
    if (query.activeDate) params.activeDate = query.activeDate;
    if (query.policyIds) params.policyIds = query.policyIds;
    if (query.name) params.name = query.name;
    if (query.rut) params.rut = query.rut;
    if (query.groupName) params.groupName = query.groupName;
    if (query.page) params.page = query.page;
    if (query.size) params.size = query.size;
    const response = await this.client.get(
      `${apiPrefix}${v2}/companies/${companyId}/stock`,
      { params }
    );
    return response.data;
  }

  async getEmployeeDependentsWithCoverages(companyId, employeeId, query = {}) {
    const params = {};
    if (query.coverageStatus) params.coverageStatus = query.coverageStatus;
    const response = await this.client.get(
      `${apiPrefix}${v2}/companies/${companyId}/employees/${employeeId}/coverage-dependents`,
      { params }
    );
    return response.data;
  }

  async previewIncorporation(payload) {
    const response = await this.client.post(
      `${apiPrefix}${v2}/stock-incorporations/preview`,
      payload
    );
    return response.data;
  }

  async previewDeregistration(companyId, payload) {
    const response = await this.client.post(
      `${apiPrefix}${v2}/companies/${companyId}/stock-deregistration/preview`,
      payload
    );
    return response.data;
  }

  async findAll({
    holdingRut,
    holdingName,
    subholdingName,
    companyName,
    companyRut,
    employeeId,
    employeeStatus,
    page,
    size
  }) {
    const response = await this.client.get(`${apiPrefix}${v2}/companies`, {
      params: {
        holdingRut,
        holdingName,
        subholdingName,
        companyName,
        companyRut,
        employeeId,
        employeeStatus,
        page,
        size
      }
    });
    return response.data;
  }

  async resendWelcomeKit(companyId) {
    const response = await this.client.post(
      `${apiPrefix}${v2}/companies/${companyId}/resend-welcome-kit`
    );
    return response.data;
  }
}
